module.exports = __webpack_public_path__ + "static/media/car_red.097b3424.jpg";